import { gql } from '@apollo/client';

export const PROPERTY_IMAGES_FRAGMENT = gql`
  fragment PropertyImages on Property {
    images {
      list {
        url
        text
      }
    }
  }
`;

export const PROPERTY_FIRST_IMAGE_FRAGMENT = gql`
  fragment PropertyFirstImage on Property {
    images {
      first {
        url
      }
    }
  }
`;
